/**
 * VENDOR MODULES
 */
import React from 'react';

import { parsePredefinedOdds, parseVariables } from 'features/video/hooks';
import * as MediaEventStore from 'features/video/stores';

/**
 * Overlay item
 *
 * @class  OverlayItem (name)
 * @return {DOM}
 */
function OverlayItem(props) {
  const {
    index,
    position_y,
    position_x,
    value,
  } = props;

  const [{ event_results }] = MediaEventStore.useMediaEventContext();

  const overlay_temp_id = `overlay-html-${index}`;
  const styles = {
      top:  `${(parseInt(position_y) / 2 )+ 50}%`,
      left: `${(parseInt(position_x) / 2) + 50}%`,
      /**
       * There should not be a scale factor here, acuse the whole TV is
       * scaled using the scaleWindow()
       */
      // zoom: this.scale_factor,
  };

  let interpolated_html = value;
  interpolated_html = parsePredefinedOdds({
    string_html: interpolated_html,
    source_data: event_results,
    sport_id: event_results.sport_id,
  });
  interpolated_html = parseVariables({
    string_html: interpolated_html,
    source_data: event_results,
    sport_id: event_results.sport_id,
  });

  return (
    <div
      className={`html-overlay-item ${overlay_temp_id}`}
      style={styles}
      dangerouslySetInnerHTML={{ __html: interpolated_html }}
    >
    </div>
  );
}

export default OverlayItem;

